import { useEffect, useState } from "react";
import { vehicleCancellationApi } from "serverApi";
import { useParams } from "react-router-dom";

import { Attachment } from "types";

export default function useAttachments(idChange, cancellationReason) {
    const [isAttachmentsFetching, setIsAttachmentsFetching] = useState(true);
    const [attachments, setAttachments] = useState<Attachment[]>([]);
    const { idObject } = useParams();

    useEffect(() => {
        const getAttachments = async () => {
            const [error, res] = await vehicleCancellationApi.getCancellationAttachments(idObject, idChange, cancellationReason);

            if (error) {
                setIsAttachmentsFetching(false);
                return;
            }

            if (res.ok && res.body) {
                setAttachments(res.body);
            }

            setIsAttachmentsFetching(false);
        };

        getAttachments();
    }, [cancellationReason]);

    return {
        attachments,
        isAttachmentsFetching,
    };
}
